import Ticker from 'react-ticker';
import PageVisibility from 'react-page-visibility'
import {useState} from "react";


export const Roll = () => {
    const words = ['Колдуй отсюда! ', 'Премьера в эфире 31 декабря в 21.00 '];

    const [pageIsVisible, setPageIsVisible] = useState(true);

    const handleVisibilityChange = (isVisible) => {
        setPageIsVisible(isVisible)
    }

    return (
        <PageVisibility onChange={handleVisibilityChange}>
            {pageIsVisible && (
                <Ticker>
                    {() => (
                        words.map((item,index) => <div key={index}>{item}</div>)
                    )}
                </Ticker>
            )}
        </PageVisibility>
    )
}